import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, NAV } from "@/data/content";
import { trackCall } from "@/lib/analytics";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#0b1120] text-[#e9e3d8] pt-20 pb-24 md:pb-10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-5">
            <img src="/brand/logo.png" alt="Perth Tiling WA" loading="lazy" decoding="async" className="h-16 md:h-20 w-auto object-contain mb-6" />
            <p className="text-[#94a3b8] font-light leading-relaxed max-w-sm">
              Perth's complete tiling specialists — from everyday ceramics and mosaics to large-format porcelain and
              natural stone, for the state's finest residential and commercial spaces.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline !text-[#94a3b8] mb-6">Explore</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.label}>
                  <a href={n.href} className="text-[#e2e8f0] hover:text-[#c9a87c] transition-colors">{n.label}</a>
                </li>
              ))}
              <li><a href="/services" data-testid="footer-link-services" className="text-[#e2e8f0] hover:text-[#c9a87c] transition-colors">All Services</a></li>
              <li><a href="/areas" data-testid="footer-link-areas" className="text-[#e2e8f0] hover:text-[#c9a87c] transition-colors">Areas We Serve</a></li>
              <li><a href="/about" data-testid="footer-link-about" className="text-[#e2e8f0] hover:text-[#c9a87c] transition-colors">About</a></li>
              <li><a href="/contact" data-testid="footer-link-contact" className="text-[#e2e8f0] hover:text-[#c9a87c] transition-colors">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline !text-[#94a3b8] mb-6">Contact</p>
            <ul className="space-y-4">
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} onClick={() => trackCall("footer")} className="flex items-center gap-3 text-[#e2e8f0] hover:text-[#c9a87c] transition-colors">
                  <Phone className="h-4 w-4 text-[#c9a87c]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-[#e2e8f0] hover:text-[#c9a87c] transition-colors break-all">
                  <Mail className="h-4 w-4 text-[#c9a87c] shrink-0" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-[#e2e8f0]">
                <MapPin className="h-4 w-4 text-[#c9a87c]" /> {CONTACT.area}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#94a3b8] text-sm">© {new Date().getFullYear()} Perth Tiling WA. All rights reserved.</p>
          <a href="/admin/login" data-testid="footer-admin-link" className="text-[#94a3b8] hover:text-[#c9a87c] text-xs uppercase tracking-[0.2em] transition-colors">
            Admin
          </a>
        </div>
      </div>
    </footer>
  );
}
